type BuildBasketSumArgs = {
  totalUnit: number;
  totalUnitDiscounted: number;
  totalUnitExclVatDiscounted: number;
  totalDeposit: number;
  totalDepositExclVat: number;
  totalOrderDiscount: number;
  totalOrderDiscountable: number;
};

export type BasketSum = {
  unitPriceSubTotalInclVat: number;
  unitPriceTotalInclVat: number;
  unitPriceTotalExclVat: number;
  depositTotalInclVat: number;
  depositTotalExclVat: number;
  /** The order discount applied after the engine's cap, for the footer row. */
  orderDiscountTotalInclVat: number;
  /** What an order discount can take at most, for the modal's guard. */
  orderDiscountableTotalInclVat: number;
};

/**
 * The deposit is charged on top of the discounted product total and is never
 * discounted itself. Both VAT bases must move together: anything deriving VAT
 * as incl - excl reports the deposit's net amount as tax otherwise.
 */
export function buildBasketSum({
  totalUnit,
  totalUnitDiscounted,
  totalUnitExclVatDiscounted,
  totalDeposit,
  totalDepositExclVat,
  totalOrderDiscount,
  totalOrderDiscountable
}: BuildBasketSumArgs): BasketSum {
  return {
    unitPriceSubTotalInclVat: totalUnit,
    unitPriceTotalInclVat: totalUnitDiscounted + totalDeposit,
    unitPriceTotalExclVat: totalUnitExclVatDiscounted + totalDepositExclVat,
    depositTotalInclVat: totalDeposit,
    depositTotalExclVat: totalDepositExclVat,
    orderDiscountTotalInclVat: totalOrderDiscount,
    orderDiscountableTotalInclVat: totalOrderDiscountable
  };
}
